const search = () => {


    jQuery('#searchBtn').on('click', function() {
        jQuery('#searchForm > form').slideToggle();
    })
}

export default search;